module.exports = __webpack_public_path__ + "img/1539261965.2c4476f4.jpg";